// İSG uzmanı portalı — auth-gated uygulama düzeni (S34-3 Carbon UI Shell, design review
// `docs/reviews/S34-carbon-phase2-plan.md` §3). Kabuk: header (48px, hiç kaymaz) + kenar
// çubuğu (kendi kaydırma bölgesi + rail toggle) + `<main>` (SAYFANIN TEK kaydırıcısı, M6).
// Erişim kapıları HER ZAMANKİYLE BİREBİR AYNI — yalnız görünüm, gruplama ve gezinme
// mimarisi değişti, hangi sonda hangi menüyü gösterdiği DEĞİŞMEDİ.
//
// **Üç bölüm (owner kararı, S34 koordinasyon talimatı — `S34-carbon-phase2.md`'nin S34-3
// slice tanımının ÜSTÜNE geçer):** Operasyon (Panel · Çalışma İzinleri +çocuklar · Kontrol ·
// Saha Girişi · Ziyaretçiler) · Uyum Yönetimi (Taşeron/Yüklenici · Eğitimler · Risk
// Değerlendirme · Belge Şemaları · Çalışma İzni Tipleri) · Sistem (Kullanıcılar · Ayarlar ·
// Yönetim · Mobil Uygulama). Üçüncü bölümün adı review M9'un bulduğu çakışmayı (bir "Yönetim"
// bölümünün içinde bir "Yönetim" öğesi) zaten çözer. Tek bir düz `items` dizisi kurulur, her
// öğe kendi `section`ını taşır (`SideNav.tsx`'in dosya başlığı notu — ardışık aynı `section`
// TEK bir `<ul aria-labelledby>`ye toplanır, bu artık İKİ ayrı `<SideNav>` + aralarında elle
// bir ayraç YERİNE TEK `<nav>`).
//
// "Çalışma İzinleri" 3 alt-öğeli bir grup (Onay bekleyen/Aktif/Tümü) — S33 Slice 4 QA fix
// (OWNER DECISION, `S33-4-list-pages-qa.md` §5) bunu kurar: `PermitsListPage.tsx` `?status=`
// sorgu parametresini iki yönlü senkronlar (`useSearchParams`), `SideNav.tsx`'in `matchSearch`
// alanı `NavLink`'in `isActive`'inin yalnız `pathname` karşılaştırdığı (react-router@7)
// sınırlamasını çözer — aynı `/permits` pathname'ini paylaşan 3 satırdan yalnız `search`ü
// eşleşen TEK'i aktif görünür. Grup başlığı (`permits.nav`) expanded modda TIKLANAMAZ
// (`SideNav.tsx`'in dosya başlığı notu); rail modda TEK bir linke çöker (flyout YOK, review
// M5) — o linkin tooltip/`sr-only` metni `railLabel` alanıyla BURADAN beslenir (bkz. altta),
// çünkü "hangi çocuğun sayısı aciliyet taşıyor" bilgisi paylaşılan `SideNav`in DEĞİL bu
// sayfanın işidir (aynı desen: `Tag`in hazard işaretçisi `icon` slotundan gelir).
//
// **Rail (S34-3, review §3).** Toggle durumu `useNavRailCollapsed()` ile kullanıcı başına
// kalıcı (`uiPrefs.ts`) — `useAuthStore`dan SENKRON okunur (`useMe` DEĞİL), bu yüzden
// yeniden yüklemede kenar çubuğu expanded→rail SIÇRAMAZ (review §3 "the reload jump").
//
// **`<main>` SAYFANIN TEK kaydırıcısı (M6).** Kök `h-dvh` + `flex flex-col`; header sabit
// (48px), gövde satırı `min-h-0` (flex çocuklarının taşmasını `<main>`in kendi
// `overflow-y-auto`suna devretmesi İÇİN ZORUNLU — `min-h-0` olmadan flex item'lar içeriği
// kadar büyür, `overflow` hiç TETİKLENMEZ). `SecurityDeskPage.tsx`in yapışkan bağlam çubuğu
// (`top-0`) ve şema editörünün yapışkan alt-footer'ları (`bottom-0`) bu sayede DOKUNULMADAN
// çalışmaya devam eder — ikisi de en yakın kaydırma ATASI olarak artık `<main>`i bulur (eskiden
// `<html>`/`<body>`, davranış aynı). Rota değişince hem odak HEM `scrollTop` sıfırlanır (yeni;
// eskiden yalnız odak taşınıyordu — `main` artık kendi kaydırma durumunu tuttuğundan bir
// sonraki sayfa önceki sayfanın kaydırma konumuyla AÇILMASIN diye).
//
// Klavye yolu: header → nav (rail toggle dahil, nav'ın son satırı) → main (DOM sırası, sekme
// sırası doğal). `mainRef` + `tabIndex={-1}` + `useLocation().pathname` bağımlı `useEffect`
// (aynı desen: web-supplier `AnalysisReviewPane.tsx`'in programatik odak
// hedefleri).

import { SideNav, type SideNavItem, cn, permitsApi } from '@isgportal/shared';
import { useQuery } from '@tanstack/react-query';
import {
  ClipboardCheck,
  FileCog,
  GraduationCap,
  HardHat,
  KeyRound,
  LayoutDashboard,
  ListChecks,
  QrCode,
  SearchCheck,
  ShieldAlert,
  SlidersHorizontal,
  Smartphone,
  UserCog,
  Users,
} from 'lucide-react';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation } from 'react-router-dom';
import { AppHeader } from '../components/AppHeader';
import { useAdminAccess } from '../lib/adminAccess';
import { useContractorsAccess } from '../lib/contractorsAccess';
import { useDepartmentReviewAccess } from '../lib/departmentReviewAccess';
import { usePermitTypesAccess } from '../lib/permitTypesAccess';
import { usePermitsAccess } from '../lib/permitsAccess';
import { permitsKeys } from '../lib/permitsKeys';
import { useRiskAccess } from '../lib/riskAccess';
import { useDocumentSchemasAccess } from '../lib/schemasAccess';
import { useSecurityAccess } from '../lib/securityAccess';
import { useSettingsAccess } from '../lib/settingsAccess';
import { useTrainingAccess } from '../lib/trainingAccess';
import { useNavRailCollapsed } from '../lib/uiPrefs';
import { useUsersAccess } from '../lib/usersAccess';
import { useVisitsAccess } from '../lib/visitsAccess';

export function AppLayout() {
  const { t } = useTranslation();
  // Yönetim menüsü yalnız sistem-admin sondası (backend) başarılıysa görünür
  // ("route gizli"); asıl yetki backend'de, bu yalnız UX görünürlüğüdür.
  const admin = useAdminAccess();
  // Ayarlar menüsü yalnız firma yetkisi (companies/get) sondası başarılıysa görünür
  // (tenant-scoped; sistem-admin şartı yok) — aynı backend-otoriteli UX deseni.
  const settings = useSettingsAccess();
  // Ziyaretçiler menüsü yalnız `visits` yetkisi sondası başarılıysa görünür (iş modülü;
  // sonda PII'siz brifing ucudur — bkz. useVisitsAccess). Asıl yetki backend'de.
  const visitors = useVisitsAccess();
  // Taşeron/Yüklenici menüsü yalnız `contractors` yetkisi sondası başarılıysa görünür
  // (iş modülü; hafif liste probu — bkz. useContractorsAccess). Asıl yetki backend'de.
  const contractors = useContractorsAccess();
  // İş İzni menüsü yalnız `permits` yetkisi sondası başarılıysa görünür (iş modülü; hafif
  // liste probu — bkz. usePermitsAccess). Gerçek modül Value = `permits`; asıl yetki backend'de.
  const permits = usePermitsAccess();
  // Kontrol menüsü yalnız Kontrol kuyruğu sondası başarılıysa görünür (kullanıcı bir departmana ait
  // — İSG/Hekim/İK; §31 / brief 095 §3). Gerçek modül Value = `permits` + departman-rol kapısı;
  // backend §31 henüz merge değilse prob 404 → menü gizli (unavailable). Asıl yetki backend'de.
  const departmentReview = useDepartmentReviewAccess();
  // İş İzni Tipleri menüsü yalnız `permit-types` yetkisi sondası başarılıysa görünür (firma admin
  // ayar modülü; hafif liste probu — bkz. usePermitTypesAccess). Gerçek modül Value = `permit-types`;
  // asıl yetki backend'de.
  const permitTypes = usePermitTypesAccess();
  // Eğitim menüsü yalnız `training` yetkisi sondası başarılıysa görünür (iş modülü; hafif liste
  // probu — bkz. useTrainingAccess). Gerçek modül Value = `training`; asıl yetki backend'de.
  const trainings = useTrainingAccess();
  // Risk Değerlendirme menüsü yalnız `risk-assessments` yetkisi sondası başarılıysa görünür
  // (iş modülü; hafif liste probu — bkz. useRiskAccess). Gerçek modül Value = `risk-assessments`;
  // asıl yetki backend'de.
  const risk = useRiskAccess();
  // Kullanıcılar menüsü yalnız `users` yetkisi sondası başarılıysa görünür (tenant kullanıcı
  // yönetimi; hafif liste probu — bkz. useUsersAccess). Gerçek modül Value = `users`;
  // asıl yetki backend'de.
  const users = useUsersAccess();
  // Belge Şemaları menüsü yalnız `document-schemas` yetkisi sondası başarılıysa görünür (§27;
  // hafif liste probu — bkz. useDocumentSchemasAccess). Gerçek modül Value =
  // `document-schemas`; asıl yetki backend'de.
  const documentSchemas = useDocumentSchemasAccess();
  // Saha Girişi (Güvenlik) menüsü yalnız `security` yetkisi sondası başarılıysa görünür (§29,
  // S32; sonda `security:get` — bkz. useSecurityAccess). `security` rolü GENELDE bu tek menüyü
  // görür (tasarım spec'i §1: "This page may be the only page its user ever sees").
  const security = useSecurityAccess();

  // Bekleyen onay sayacı — `GET /permits?status=Submitted&pageSize=1`'in `filteredTotal`'ı
  // (api-contract §3 zarf alanı; `permitsApi.listPermits` zaten sarıyor). `Submitted` "uzmanın
  // canlı kuyruğu" — `PermitLifecycleActions.tsx`'in kendi `canApproveReject` düşüşü de aynı
  // statüye bakıyor. Yalnız `permits` erişimi VARSA sorulur (erişimsiz kullanıcı için gereksiz
  // istek yok).
  const pendingApprovalQuery = useQuery({
    queryKey: permitsKeys.listParams({ status: 'Submitted', page: 1, pageSize: 1 }),
    queryFn: () => permitsApi.listPermits({ status: 'Submitted', page: 1, pageSize: 1 }),
    enabled: permits.status === 'granted',
    staleTime: 60_000,
  });
  const pendingApprovalCount = pendingApprovalQuery.data?.filteredTotal;

  // Rail toggle — kullanıcı başına kalıcı (dosya başlığı notu).
  const [railCollapsed, setRailCollapsed] = useNavRailCollapsed();

  // Rota değişince odağı VE kaydırma konumunu `<main>`in başına taşı (dosya başlığı notu, M6).
  // `tabIndex={-1}` — programatik hedef, Tab sırasına GİRMEZ.
  const location = useLocation();
  const mainRef = useRef<HTMLElement>(null);
  // S36 #9b (QA — `S36-qa.md`, #9 FAIL) — bu efekt İLK sayfa yüklemesinde de mount olur;
  // korumasız hâli `focus()`u ilk mount'ta da çağırıp odağı `<main>`e taşıyordu, "İçeriğe geç"
  // atlama linki hiçbir zaman ilk Tab hedefi OLAMIYORDU (odak zaten `main`deydi). `prevPathnameRef`
  // başlangıç DEĞERİYLE (yalnız İLK render'da okunan `useRef` argümanı) tohumlanır — StrictMode'un
  // dev'de mount'u ÇİFT invoke etmesi DAHİL (`HeaderSearch.tsx`in dosya başlığındaki AYNI kök
  // neden) aynı pathname'de kalan HER çağrıyı atlar; yalnız pathname GERÇEKTEN DEĞİŞTİĞİNDE
  // (bir nav tıklaması) odak + kaydırma taşınır.
  const prevPathnameRef = useRef(location.pathname);
  useEffect(() => {
    if (prevPathnameRef.current === location.pathname) {
      return;
    }
    prevPathnameRef.current = location.pathname;
    mainRef.current?.focus();
    if (mainRef.current) {
      mainRef.current.scrollTop = 0;
    }
  }, [location.pathname]);

  // Operasyon — owner kararı S34-3: Panel · Çalışma İzinleri (+çocuklar) · Kontrol · Saha
  // Girişi · Ziyaretçiler.
  const operationsItems: SideNavItem[] = [
    { label: t('layout.dashboard'), to: '/', icon: LayoutDashboard },
    ...(permits.status === 'granted'
      ? [
          {
            label: t('permits.nav'),
            to: '/permits',
            icon: ClipboardCheck,
            // Rail'de "Çalışma İzinleri" TEK linke çöker (flyout yok) — o linkin tooltip/
            // `sr-only` metni bekleyen sayıyı da taşır (dosya başlığı notu). Sayı yoksa/0'sa
            // `SideNav` zaten `label`e düşer (bkz. `SideNav.tsx`in `railLabel` alanı).
            railLabel: pendingApprovalCount
              ? t('layout.rail.permitsPending', { count: pendingApprovalCount })
              : undefined,
            // Owner review B2 item 7 — izin DETAYI (`/permits/{uuid}`) grubu vurgusuz
            // bırakıyordu (çocukların HİÇBİRİ pathname'i TAM eşleşmiyor). `matchSearch`
            // taşıyan üç çocuk (Bekleyen onay/Aktif/Tümü) BUNDAN etkilenmez, TAM eşleşme
            // ister (owner kararı — `SideNav.tsx`'in dosya başlığı notu).
            matchPrefixes: ['/permits'],
            children: [
              {
                label: t('permits.nav.pendingApproval'),
                to: '/permits',
                search: '?status=Submitted',
                count: pendingApprovalCount || undefined,
                matchSearch: (search) => search.get('status') === 'Submitted',
              },
              {
                label: t('permits.nav.active'),
                to: '/permits',
                search: '?status=Active',
                matchSearch: (search) => search.get('status') === 'Active',
              },
              {
                label: t('permits.nav.all'),
                to: '/permits',
                matchSearch: (search) => !search.has('status'),
              },
            ],
          } as SideNavItem,
        ]
      : []),
    ...(departmentReview.status === 'granted'
      ? [
          {
            label: t('departmentReview.nav'),
            to: '/department-review',
            icon: SearchCheck,
            // Owner review B2 item 7 — kuyruk DETAYI (`/department-review/{uuid}`) alt-ağacı.
            matchPrefixes: ['/department-review'],
          } as SideNavItem,
        ]
      : []),
    ...(security.status === 'granted'
      ? [{ label: t('security.nav'), to: '/security', icon: QrCode }]
      : []),
    ...(visitors.status === 'granted'
      ? [
          {
            label: t('visitors.nav'),
            to: '/visitors',
            icon: Users,
            // Owner review B2 item 7 — Ziyaret geçmişi/Güvenlik brifingi sekmeleri
            // (`VisitorsShell.tsx`) aynı `to`yu PAYLAŞMAZ, ayrı rotadır; grup DEĞİL bu yüzden
            // `matchPrefixes` doğrudan yaprak öğede.
            matchPrefixes: ['/visitors'],
          } as SideNavItem,
        ]
      : []),
  ];

  // Uyum Yönetimi — owner kararı S34-3: Taşeron/Yüklenici · Eğitimler · Risk Değerlendirme ·
  // Belge Şemaları · Çalışma İzni Tipleri.
  // Owner review B2 item 7 — hepsi kendi DETAY/sekme alt-ağacını taşır (kontrat sayfası +
  // `/contractors/{uuid}`, eğitim listesi + `/trainings/new|{uuid}`, risk listesi +
  // `/risk-assessments/new|{uuid}`, Belge Şemaları'nın types/formats/samples ağacı, Çalışma
  // İzni Tipleri'nin dört sekmesi — `PermitTypesShell.tsx`); `matchPrefixes` HEPSİNE eklendi ki
  // o alt sayfalardayken sahibi menü öğesi vurgusunu KAYBETMESİN.
  const complianceItems: SideNavItem[] = [
    ...(contractors.status === 'granted'
      ? [
          {
            label: t('contractors.nav'),
            to: '/contractors',
            icon: HardHat,
            matchPrefixes: ['/contractors'],
          } as SideNavItem,
        ]
      : []),
    ...(trainings.status === 'granted'
      ? [
          {
            label: t('trainings.nav'),
            to: '/trainings',
            icon: GraduationCap,
            matchPrefixes: ['/trainings'],
          } as SideNavItem,
        ]
      : []),
    ...(risk.status === 'granted'
      ? [
          {
            label: t('risk.nav'),
            to: '/risk-assessments',
            icon: ShieldAlert,
            matchPrefixes: ['/risk-assessments'],
          } as SideNavItem,
        ]
      : []),
    ...(documentSchemas.status === 'granted'
      ? [
          {
            label: t('documentSchemas.nav'),
            to: '/document-schemas',
            icon: FileCog,
            matchPrefixes: ['/document-schemas'],
          } as SideNavItem,
        ]
      : []),
    ...(permitTypes.status === 'granted'
      ? [
          {
            label: t('permitTypes.nav'),
            to: '/permit-types',
            icon: ListChecks,
            matchPrefixes: ['/permit-types'],
          } as SideNavItem,
        ]
      : []),
  ];

  // Sistem — owner kararı S34-3: Kullanıcılar · Ayarlar · Yönetim · Mobil Uygulama. Mobil
  // Uygulama (§26, D4) herhangi authenticated okur (`GET /app-settings`) — ayrı yetki sondası
  // yok.
  const systemItems: SideNavItem[] = [
    ...(users.status === 'granted' ? [{ label: t('users.nav'), to: '/users', icon: UserCog }] : []),
    ...(settings.status === 'granted'
      ? [
          {
            label: t('settings.nav'),
            to: '/settings/company',
            icon: SlidersHorizontal,
            // Owner review B2 item 7 — `to` yalnız ilk sekme (Şirket); Şube/Saha sekmeleri
            // (`SettingsShell.tsx`) aynı `/settings` önekini paylaşır.
            matchPrefixes: ['/settings'],
          } as SideNavItem,
        ]
      : []),
    ...(admin.status === 'granted'
      ? [
          {
            label: t('admin.nav'),
            to: '/admin/roles',
            icon: KeyRound,
            // Owner review B2 item 7 — `to` yalnız ilk sekme (Roller); diğer sekmeler
            // (Firmalar/Kiosk/Mobil Uygulama) VE rol/firma/şube DETAY sayfaları
            // (`router.tsx`'in `AdminGate` altındaki düz çocukları) aynı `/admin` önekini
            // paylaşır.
            matchPrefixes: ['/admin'],
          } as SideNavItem,
        ]
      : []),
    { label: t('layout.mobileApp'), to: '/mobile-app', icon: Smartphone },
  ];

  const items: SideNavItem[] = [
    ...operationsItems.map((item) => ({ ...item, section: t('layout.navGroup.operations') })),
    ...complianceItems.map((item) => ({ ...item, section: t('layout.navGroup.compliance') })),
    ...systemItems.map((item) => ({ ...item, section: t('layout.navGroup.system') })),
  ];

  return (
    <div className="flex h-dvh flex-col bg-bg">
      {/* S36 #9 — WCAG 2.4.1 atla-bağlantısı. `AppHeader` (arama düğmesi dahil) `<main>`den ÖNCE
          render edilir, yani Tab ile sayfaya girince ilk durak arama olur; bu bağlantı klavye
          kullanıcısına navigasyonu ATLAMA seçeneği verir. Salt yerel çapa davranışı (`onClick`/
          `preventDefault` YOK) — hedef zaten `tabIndex={-1}` taşıdığından (aşağıdaki `<main>`)
          tarayıcı fragment gezinmesinde odağı da oraya taşır, ayrı bir JS köprüsü gerekmez. */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[var(--z-toast)] focus:rounded-md focus:bg-surface focus:px-4 focus:py-2 focus:text-sm focus:font-medium focus:text-fg focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-ring"
      >
        {t('layout.skipToContent')}
      </a>
      <AppHeader />
      <div className="flex min-h-0 flex-1">
        <aside
          className={cn(
            'hidden shrink-0 flex-col border-r border-border bg-surface transition-[width]',
            'duration-100 ease-[cubic-bezier(0.2,0,0.38,0.9)] motion-reduce:transition-none md:flex',
            railCollapsed ? 'w-12' : 'w-64',
          )}
        >
          <SideNav
            items={items}
            ariaLabel={t('layout.nav.primary')}
            collapsed={railCollapsed}
            onToggleCollapsed={() => setRailCollapsed(!railCollapsed)}
            collapseLabel={t('layout.rail.collapse')}
            expandLabel={t('layout.rail.expand')}
            className="h-full"
          />
        </aside>

        <main
          id="main-content"
          ref={mainRef}
          tabIndex={-1}
          className="min-w-0 flex-1 overflow-y-auto px-8 pt-6 pb-8 outline-none"
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
}
